import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
// import RLDD from "react-list-drag-and-drop/lib/RLDD";
import {Alert} from "react-bootstrap";

class EditFaqs extends Component {

    constructor(props) {
        super(props);
        this.state = {
            pageId: null,
            faqs: [],
            faqCategories: [],
            categoryId: null,
            success: false
        };

        this.handleRLDDChange = this.handleRLDDChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    async componentDidMount() {
        let categoryId = this.props.match.params.categoryId;
        let pageId = this.props.match.params.pageId;

        const res = await axios.get(`/api/pages/faqs`)
        const { content } = res.data

        this.setState({ faqCategories : content })
        this.setState({ categoryId : categoryId })
        this.setState({ pageId : pageId })

        const categoryIndex = content.findIndex(x => x.id == categoryId);
        let category = content[categoryIndex];

        this.setState({ faqs : category.items })
    }

    handleRLDDChange(reorderedItems) {
        this.setState({ faqs: reorderedItems });
    }

    async handleSubmit(){
        let faqsCategories = this.state.faqCategories;
        const categoryIndex = faqsCategories.findIndex(x => x.id == this.state.categoryId);
        let faqs = faqsCategories[categoryIndex];
        faqs.items = this.state.faqs;
        faqsCategories[categoryIndex] = faqs;
        try {
            const data = {
                title: "Faqs",
                content: faqsCategories
            }
            await axios.put(`/api/pages/faqs`, data);
            this.setState({ success: true });
        } catch (e) {
            console.log(e);
        }
    }

    render() {
        return (
            <section className="contact-wrapper">
                <div className="container">
                    {
                        this.state.success && <Alert variant="success">Content updated successfully</Alert>
                    }
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <div className="contact_form">
                                <h3 className="title">Edit FAQ's content</h3>
                                <div className="container">
                                    <div className="row">
                                        <div className="col-1">#</div>
                                        <div className="col-3">Question</div>
                                        <div className="col-7">Answer</div>
                                        <div className="col-1">Action</div>
                                    </div>
                                    {/*
                                    <RLDD
                                        items={this.state.faqs}
                                        itemRenderer={(item, index) => {
                                            return (
                                                <div className="card my-2 py-2 px-2" style={{ width: "100%"}}>
                                                    <div className="row">
                                                        <div className="col-1">{ index + 1 }</div>
                                                        <div className="col-3">
                                                            { item.q }
                                                        </div>
                                                        <div className="col-7">
                                                            { item.a }
                                                        </div>
                                                        <div className="col-1">
                                                            <Link to={`/admin/dashboard/pages/${this.state.pageId}/${this.state.categoryId}/${item.id}`}>
                                                                <button
                                                                    className="btn btn-primary btn-sm"
                                                                ><i className="fa fa-pencil-alt"></i> Edit</button>
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        }}
                                        onChange={this.handleRLDDChange}
                                    />
                                    */}
                                    <div className="submit-btn mt-3">
                                        <input
                                            id="submit"
                                            className="btn btn-primary"
                                            value="Save order"
                                            type="button"
                                            name="submit"
                                            onClick={this.handleSubmit}
                                        />

                                        <Link to={`/admin/dashboard/pages/${this.state.pageId}`}>
                                            <button
                                                className="btn btn-warning"
                                            ><i className="fa fa-undo"></i> Return</button>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default withRouter(EditFaqs);
